module.exports = __webpack_public_path__ + "img/freewave1_feature_02.29e6eb89.jpg";